import { AddressDto } from '../../../interfaces/IAssignment'

export function isCoordsWithoutAddressMissingAlias(address?: AddressDto | null): boolean {
  const hasCoords =
    address?.latitude !== undefined &&
    address?.latitude !== null &&
    address?.longitude !== undefined &&
    address?.longitude !== null
  if (!hasCoords) return false
  const hasStreetAddress = !!address?.streetAddress && address.streetAddress.trim().length > 0
  if (hasStreetAddress) return false
  const hasAlias = !!address?.alias && address.alias.trim().length > 0
  return !hasAlias
}

export function parseCoordinatePair(input: string): { lat: number; lon: number } | null {
  if (!input) return null
  const trimmed = input.trim()
  if (!trimmed) return null

  const hasSemicolon = trimmed.includes(';')
  const hasWhitespace = /\s/.test(trimmed)

  let pieces: string[]
  if (hasSemicolon || hasWhitespace) {
    pieces = trimmed.split(/[;\s,]+/).filter(Boolean)
  } else {
    pieces = trimmed
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
  }

  let latStr: string
  let lonStr: string
  if (pieces.length === 2) {
    latStr = pieces[0]
    lonStr = pieces[1]
  } else if (pieces.length === 4) {
    latStr = `${pieces[0]}.${pieces[1]}`
    lonStr = `${pieces[2]}.${pieces[3]}`
  } else {
    return null
  }

  const lat = Number(latStr.replace(',', '.'))
  const lon = Number(lonStr.replace(',', '.'))

  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null
  if (lat < -90 || lat > 90) return null
  if (lon < -180 || lon > 180) return null
  return { lat, lon }
}

export function isValidCoordinatePair(lat?: number | null, lon?: number | null): boolean {
  const latSet = lat !== undefined && lat !== null && !Number.isNaN(lat)
  const lonSet = lon !== undefined && lon !== null && !Number.isNaN(lon)
  if (!latSet && !lonSet) return true
  if (!latSet || !lonSet) return false
  if (lat! < -90 || lat! > 90) return false
  if (lon! < -180 || lon! > 180) return false
  return true
}
